import React, { useState,useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import CheckCurrentPlan from "../../../../components/CheckCurrentPlan";
import { submitTemplate } from "../../../../utils/announcementBarApi";
import '../../../../assets/css/loader.css'; 

//Import Widgets
import SaleAnTemplateWidget from "../../../../components/Apps/AnnouncementBar/Template/SaleAnTemplateWidget";
import NewProductAnTemplateWidget from "../../../../components/Apps/AnnouncementBar/Template/NewProductAnTemplateWidget";
import NewStoreAnTemplateWidget from "../../../../components/Apps/AnnouncementBar/Template/NewStoreAnTemplateWidget";
import FreeShippingAnTemplateWidget from "../../../../components/Apps/AnnouncementBar/Template/FreeShippingAnTemplateWidget";
import NewsAnTemplateWidget from "../../../../components/Apps/AnnouncementBar/Template/NewsAnTemplateWidget";
import UpdateAnTemplateWidget from "../../../../components/Apps/AnnouncementBar/Template/UpdateAnTemplateWidget";

//Import Tabs
import ContentTab from "../../../../components/Apps/AnnouncementBar/ContentTab";
import PositionTab from "../../../../components/Apps/AnnouncementBar/PositionTab";
import StyleTab from "../../../../components/Apps/AnnouncementBar/StyleTab";
import SettingTab from "../../../../components/Apps/AnnouncementBar/SettingTab";

export default function CreateAnnouncementBar() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(true);
    const [showTemplateSelection, setShowTemplateSelection] = useState(true);
    const [activeSection, setActiveSection] = useState("Content");
    const [activeTemplateSection, setActiveTemplateSection] = useState("Sale_Announcement_Temp");
    const [selectedLayout, setSelectedLayout] = useState("sale_announcement_layout");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("sale-announcement.png");
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled Announcement Bar");
    const [newWidgetName, setNewWidgetName] = useState("");
    
    const [announcementBarTabData, setAnnouncementBarTabData] = useState({
        is_website_frontend: "",  
        message: "",  
        action_element_type: "Button",  
        action_element_button_text: "",  
        action_element_button_link: "",  
        visual_element_type: "Badge",  
        visual_element_badge_text: "",  
        is_close_button: 1,  
        bar_link: "",  
        message_on_mobile: "",  
        postion_type: "",  
        bar_size_type: "Medium",  
        font_type: "Default",  
        background_color: "",  
        message_color: "",  
        badge_color: "",  
        button_color: "",  
        bar_mobile_size_type: "Medium",    
        display_page_type: "All_Pages",    
        hide_page_type: "None",    
        visibility_on_devices: "All Devices",    
        is_bar_display_schedule : 1,    
        is_visitor_closed_bar : 1,    
        is_visitor_clicked_bar  : 1,    
        custom_css: "",   
        custom_js: "",   
    });

    // Set Template Setting And Texts when activeTemplateSection changes
        useEffect(() => {
            let message = "";
            let action_element_button_text = "";
            let visual_element_badge_text = "";
            let background_color = "";
            let message_color = "";
            let badge_color = "";
            let button_color = "";
            let postion_type = "";
        
            switch (activeTemplateSection) {
                case "Sale_Announcement_Temp":
                    message = "Don't miss our special sale event! Save up to 50% on top products";
                    action_element_button_text = "Shop Now";
                    visual_element_badge_text = "Sale";
                    background_color = "#000";
                    message_color = "#fff";
                    badge_color = "rgb(254, 129, 0)";
                    button_color = "rgb(254, 129, 0)";
                    postion_type = "inline";
                    break;
                case "New_Product_Announcement_Temp":
                    message = "Be the first to experience our newest innovation: the Quantum Headphones!";
                    action_element_button_text = "Discover Now";
                    visual_element_badge_text = "New Product";
                    background_color = "#0a3166";
                    message_color = "#fff";
                    badge_color = "#ffeb00";
                    button_color = "#a3caff";
                    postion_type = "inline";
                    break;
                case "New_Store_Announcement_Temp":
                    message = "Celebrating the grand opening of our new store in Manhattan, NYC! Come and explore.";
                    action_element_button_text = "Find Us";
                    visual_element_badge_text = "New Store";
                    background_color = "#f1f1f1";
                    message_color = "#000";
                    badge_color = "#1979fa";
                    button_color = "#1979fa";
                    postion_type = "inline";
                    break;
                case "Free_Shipping_Announcement_Temp":
                    message = "Enjoy free shipping on all orders for a limited time!";
                    action_element_button_text = "Shop Now";
                    visual_element_badge_text = "Free Shipping";
                    background_color = "linear-gradient(237deg, rgb(33, 58, 135), rgb(17, 17, 17))";
                    message_color = "#fff";
                    badge_color = "#ffeb00";
                    button_color = "#f7ec7b";
                    postion_type = "inline";
                    break;
                case "News_Announcement_Temp":
                    message = "We're proud to announce our collaboration with SpaceX. Learn more about our space-bound technology.";
                    action_element_button_text = "Read More";
                    visual_element_badge_text = "Show Now";
                    background_color = "#000";
                    message_color = "#fff";
                    badge_color = "#197bff";
                    button_color = "#ffeb00";
                    postion_type = "inline";
                    break;
                case "Update_Announcement_Temp":
                    message = "We've just rolled out Virtual Reality support! Explore the possibilities with us.";
                    action_element_button_text = "Try Now";
                    visual_element_badge_text = "Update";
                    background_color = "#d9d9d9";
                    message_color = "#000";
                    badge_color = "rgb(254, 129, 0)";
                    button_color = "#128312";
                    postion_type = "inline";
                    break;
                default:
                    message = "";
                    action_element_button_text = "";
                    visual_element_badge_text = "";
                    background_color = "";
                    message_color = "";
                    badge_color = "";
                    button_color = "";
                    postion_type = "";
            }
        
            // Update setAnnouncementBarTabData state with the data
            setAnnouncementBarTabData((prevData) => ({
                ...prevData,
                message: message,
                action_element_button_text: action_element_button_text,
                visual_element_badge_text: visual_element_badge_text,
                background_color: background_color,
                message_color: message_color,
                badge_color: badge_color,
                button_color: button_color,
                postion_type: postion_type,
            }));
        
        }, [activeTemplateSection]);

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateAnnouncementBarTabData = (key, value) => {
        setAnnouncementBarTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleContinueTemplate = () => {
      setShowTemplateSelection(false);
      setIsSubmitting(false);
      //Get the currently checked radio button
      const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
      if (selectedRadio) {
          const layoutTypeValue = selectedRadio.dataset.layout_type;
          setSelectedLayout(layoutTypeValue);
      } else {
          alert('Please select a template');
      }
  }; 

  const menuItems = [
      { key: "Content", icon: "content.png", label: "Content" },
      { key: "Position", icon: "position.png", label: "Position" },
      { key: "Style", icon: "style.png", label: "Style" },
      { key: "Settings", icon: "setting.png", label: "Settings" },
  ];

  // Handle Source Tab input change
  const handleActiveTemplateInputChange = (event) => {
      setActiveTemplateSection(event.target.value);
      //Get the currently checked radio button
      const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
      if (selectedRadio) {
          const layoutTypeValue = selectedRadio.dataset.layout_type;
          const template_image = selectedRadio.dataset.template_image;
          setSelectedLayout(layoutTypeValue);
          setSelectedTemplateImage(template_image);
      } else {
          alert('Please select a template');
      }
  };

  //Submit Review data
  const submitForm = async (e) => {
      e.preventDefault();

      setIsSubmitting(true);
      try {
        // Collect data from refs
        const settingsArray = Object.entries(announcementBarTabData).map(([key, value]) => ({
            setting_key: key,
            setting_value: value,
        }));

          // Collect data from refs
          const payload = {
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: selectedTemplateImage,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                app_type: "Announcement_Bar",
                settings: settingsArray,
          };
          
          //Api Call
          let api_response = await submitTemplate(payload);

          //Check Responce
          if (api_response.status === true) {
                toast.success(api_response.message);
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/announcement-bar');
                }, 2000); 
          } else {
              toast.error(api_response.message);
          }
      } catch (error) {
          toast.error('Oops Something Wrong. Please Try Again!' + error.message);
      } finally {
          setIsSubmitting(false);
      }
  };

  return (
    <>
      <div className="create-goole-reviews-all">
            <CheckCurrentPlan from_page={true} app_name="Announcement Bar" app_type="Announcement_Bar" app_slug="announcement-bar"/>
            {showTemplateSelection ? (
                <div className="create-goole-reviews-side">
                    <span>Select a template to start with</span>
                    <div className="card h-100">
                        <div className="label-box-flex">
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Sale_Announcement_Temp" data-layout_type="sale_announcement_layout" data-template_image="sale-announcement.png" checked={activeTemplateSection === "Sale_Announcement_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/announcement-bar/templates/sale-announcement.png`} alt="sale-announcement" />
                                    </div> 
                                    <div className="content_sub">Sale Announcement Bar</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="New_Product_Announcement_Temp" data-layout_type="new_product_announcement_layout" data-template_image="new-product-announcement.png" checked={activeTemplateSection === "New_Product_Announcement_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/announcement-bar/templates/new-product-announcement.png`} alt="new-product-announcement" />
                                    </div>
                                    <div className="content_sub">New Product Announcement Bar</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="New_Store_Announcement_Temp" data-layout_type="new_store_announcement_layout" data-template_image="new-store-announcement.png" checked={activeTemplateSection === "New_Store_Announcement_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/announcement-bar/templates/new-store-announcement.png`} alt="new-store-announcement" />
                                    </div>
                                    <div className="content_sub">New Store Announcement Bar</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Free_Shipping_Announcement_Temp" data-layout_type="free_shipping_announcement_layout" data-template_image="free-shipping-announcement.png" checked={activeTemplateSection === "Free_Shipping_Announcement_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/announcement-bar/templates/free-shipping-announcement.png`} alt="free-shipping-announcement" />
                                    </div>
                                    <div className="content_sub">Free Shipping Announcement Bar</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="News_Announcement_Temp" data-layout_type="beer_layout"  data-template_image="news-announcement.png" checked={activeTemplateSection === "News_Announcement_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/announcement-bar/templates/news-announcement.png`} alt="news-announcement" />
                                    </div>
                                    <div className="content_sub">News Announcement Bar</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Update_Announcement_Temp" data-layout_type="update_announcement_layout" data-template_image="update-announcement.png" checked={activeTemplateSection === "Update_Announcement_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/announcement-bar/templates/update-announcement.png`} alt="update-announcement" />
                                    </div>
                                    <div className="content_sub">Update Announcement Bar</div>
                                </div>
                            </label>
                        </div>
                    </div>
                    <div className="continue-template">
                        <button onClick={handleContinueTemplate}>Continue with this template</button>
                    </div>
                </div>
            ) : (
                <>
                    <div className="overlay-side-baar">
                        <div className="side-baar-inner-one">
                            <ul>
                                {menuItems.map((item) => (
                                    <li key={item.key}>
                                        <button
                                            className={activeSection === item.key ? "active" : ""}
                                            onClick={() => setActiveSection(item.key)}
                                        >
                                            <img
                                                src={`${process.env.PUBLIC_URL}/announcement-bar/icons/${item.icon}`}
                                                alt={`${item.key} icon`}
                                            />
                                            <span>{item.label}</span>
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="side-baar-inner-tow">
                            {/* Conditional Rendering for Sections */}
                            {activeSection === "Content" && (
                              <ContentTab updateAnnouncementBarTabData={updateAnnouncementBarTabData} announcementBarTabData={announcementBarTabData} />
                            )}
                            {activeSection === "Position" && (
                              <PositionTab updateAnnouncementBarTabData={updateAnnouncementBarTabData} announcementBarTabData={announcementBarTabData} />
                            )}
                            {activeSection === "Style" && (
                              <StyleTab updateAnnouncementBarTabData={updateAnnouncementBarTabData} announcementBarTabData={announcementBarTabData}/>
                            )}
                            {activeSection === "Settings" && (
                              <SettingTab updateAnnouncementBarTabData={updateAnnouncementBarTabData} announcementBarTabData={announcementBarTabData} />
                            )}
                        </div>
                    </div>
                </>
            )}
            <div className="create-goole-reviews-right">
                <div className="content-wrapper count-add-class">
                    <div className="source-header-row">
                        <h2><Link to="/customer/apps/announcement-bar"><i className="fa fa-angle-left" aria-hidden="true"></i></Link> Back</h2>
                        <div className="untitled-widget-name">
                            <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/announcement-bar/announcement-bar.svg`} alt="announcement-bar"/>{ widgetName }</button>
                            <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                        </div>
                        <div className='submit-google-review'>
                          <button type="button" onClick={submitForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                          <Link to="/customer/apps/announcement-bar/pricing/single" className="view-plan">View Plans</Link>
                          <Link to="/customer/apps/announcement-bar" className="close-button">Close</Link></div>
                    </div>
                    <div className="source-title-row">Announcement Bar <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                    {/*Check template type*/}
                    {activeTemplateSection === "Sale_Announcement_Temp" && (
                      <SaleAnTemplateWidget announcementBarTabData={announcementBarTabData}/>
                    )}

                    {activeTemplateSection === "New_Product_Announcement_Temp" && (
                      <NewProductAnTemplateWidget announcementBarTabData={announcementBarTabData}/>
                    )}

                    {activeTemplateSection === "New_Store_Announcement_Temp" && (
                      <NewStoreAnTemplateWidget announcementBarTabData={announcementBarTabData}/>
                    )}

                    {activeTemplateSection === "Free_Shipping_Announcement_Temp" && (
                      <FreeShippingAnTemplateWidget announcementBarTabData={announcementBarTabData}/>
                    )}

                    {activeTemplateSection === "News_Announcement_Temp" && (
                      <NewsAnTemplateWidget announcementBarTabData={announcementBarTabData}/>
                    )}

                    {activeTemplateSection === "Update_Announcement_Temp" && (
                      <UpdateAnTemplateWidget announcementBarTabData={announcementBarTabData}/>
                    )}
                </div>
            </div>
        </div>

        {/* Rename Popup */}
        {renameWidgetNameModel && (
            <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                <div className="bg-white p-3 rounded-lg shadow-lg">
                    <h3 className="text-lg font-semibold">Rename Widget</h3>
                    <label>Widget Name</label>
                    <input
                        type="text"
                        className="border p-2 w-full mt-2"
                        value={newWidgetName}
                        onChange={(e) => setNewWidgetName(e.target.value)}
                    />
                    <div className="mt-3 flex justify-end">
                        <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                            Cancel
                        </button>
                        <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
} 